import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BigPicklistInput, TitleTextMedium } from 'Packages/FacetDesign/Components';

export const AnalyzeYourExpensesOverride = buildFacetDesignOverride()
  .nameOverride('questionTitle', { _component: () => TitleTextMedium }, overrideReadOnly)
  .typeOverride('picklist', { _component: () => BigPicklistInput }, { ordinal: 200 });
